<div class="rs-percent-control">
  <mat-form-field appearance="outline">
    <mat-label>{{placeholder | translate}}</mat-label>
    <input [formControl]="rsFormControl" matInput mask="percent" suffix="%">
    <mat-error *ngIf="rsFormControl.invalid && rsFormControl.touched">{{ "placeholders.required" | translate }}</mat-error>
    <ng-content></ng-content>
  </mat-form-field>
</div>
